// extracted by mini-css-extract-plugin
export default {"serviceWrapper":"_Service_serviceWrapper__bvtfQ","service":"_Service_service__6l7ns","serviceImg":"_Service_serviceImg__izBcW","serviceInfo":"_Service_serviceInfo__w3MTc"};